import {Screen} from '../../Common/stores/Screen';
import {TemplateCollection} from './TemplateCollection';
import {TemplateField} from './TemplateField';

export class TemplateScreen extends Screen {
    constructor(screen, name) {
        super(screen, name);
        this.collection = new TemplateCollection(null);
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields);
    }

    createNewField(field) {
        return new TemplateField(field, this);
    }
}
